import '../../../commonScript/index.js';